import assetIcChat from './ic-chat.svg';
export enum FooterIconName {
  Chat = 'Chat',
}

export const footerIconAssets: {
  [key in FooterIconName]: string;
} = {
  [FooterIconName.Chat]: assetIcChat,
};
